import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodPhysicalInventory  {
    _originalTypeClassName = "zERP.BO.GoodPhysicalInventory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodPhysicalInventory.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.WarehouseContents = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.DateCreated = null;
this.DateTransaction = null;
this.Finalized = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
DateCreated:any;
DateTransaction:any;
Finalized:any;
Entity:any;
WarehouseContents:any;
GoodTransferTransaction:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setWarehouseContents = ($this, items) => {
                if (items == null) items = [];
                if ($this.WarehouseContents == null) $this.WarehouseContents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WarehouseContents.length > 0) {
                    Domain.GoodPhysicalInventory.removeWarehouseContents($this, $this.WarehouseContents[0]);
                }

                Domain.GoodPhysicalInventory.addManyWarehouseContents($this, copyItems);
            }
static addManyWarehouseContents = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodPhysicalInventory.addWarehouseContents($this, items[i]);
                }
            }
static addWarehouseContents = ($this, item) => {
                if ($this.WarehouseContents == null) $this.WarehouseContents = [];
                if (item == null || $this.WarehouseContents.indexOf(item) > -1) return;
                $this.WarehouseContents.push(item);
}
static addRangeWarehouseContents = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodPhysicalInventory.addWarehouseContents($this, item));
            }
static removeWarehouseContents = ($this, item) => {
                if ($this == null || $this.WarehouseContents == null || $this.WarehouseContents.indexOf(item) === -1) return;
                var _index = $this.WarehouseContents.indexOf(item);
                $this.WarehouseContents.splice(_index, 1);
}
static clearWarehouseContents = ($this) => { $this.WarehouseContents = null; }
static setGoodTransferTransaction = ($this, value) => {
var oldValue = $this.GoodTransferTransaction;
$this.GoodTransferTransaction = value;
if (value != null) {
if (oldValue != null && oldValue.PhysicalInventory != null) { oldValue.PhysicalInventory = null; }
if ($this.GoodTransferTransaction.PhysicalInventory !== $this) {
Domain.GoodTransferTransaction.setPhysicalInventory(value, $this);
}
}
}

static CreateNewWarehouse($this: any, from: any): any{if (from == null) {throw Error("Warehouse not given");}
if (CLMS.Framework.Number.GreaterThan(() => $this.WarehouseContents.linq.count((x) => CLMS.Framework.Number.Equal(() => x.Warehouse.Id, () => from.Id)), () => 0)) {throw Error("Duplicate warehouse");}
let w = new Domain.GoodPhysicalInventoryWarehouse();
Domain.GoodPhysicalInventoryWarehouse.setWarehouse(w, from);
$this?.WarehouseContents?.add(w);
return w;
}
static FindWarehouse($this: any, warehouse: any): any{if (warehouse == null) {throw Error("Warehouse not given");}
let warehouses = $this?.WarehouseContents?.linq?.where((x) => CLMS.Framework.Number.Equal(() => x.Warehouse.Id, () => warehouse.Id))?.toArray();
if (CLMS.Framework.Number.GreaterThan(() => warehouses.length, () => 1)) {throw Error("Can't have duplicate warehouse contents");}
if (CLMS.Framework.Number.Equal(() => warehouses.length, () => 1)) {return warehouses[0];}
if (CLMS.Framework.Number.Equal(() => warehouses.length, () => 0)) {return Domain.GoodPhysicalInventory.CreateNewWarehouse($this, warehouse);}
throw Error("Can't be here obviously");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}